import { render, staticRenderFns } from "./revenue.vue?vue&type=template&id=48c09d7c&scoped=true&"
import script from "./revenue.vue?vue&type=script&lang=js&"
export * from "./revenue.vue?vue&type=script&lang=js&"
import style0 from "./revenue.vue?vue&type=style&index=0&id=48c09d7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c09d7c",
  null
  
)

export default component.exports